import React, { type FC, useCallback, useEffect, useState } from "react";
import { Button, toast } from "@heroui/react";
import { FormattedMessage, useIntl } from "react-intl";
import { sendEmailVerification } from "firebase/auth";

import { AuthLayout } from "./AuthLayout";
import { auth } from "@domain/api/firebase/firebase";
import { getFirebaseErrorMessageByError } from "@domain/api/firebase/firebaseErrorMessages";

const addZeros = (value: number) => (value > 9 ? value.toString() : `0${value}`);

const getInitialTime = () => {
    const lStime = localStorage.getItem("confirmAgainAfter");
    if (lStime) {
        const timeLeft = Math.floor((+lStime - new Date().getTime()) / 1000);
        if (timeLeft > 0) {
            return timeLeft;
        }
        localStorage.removeItem("confirmAgainAfter");
    }
    return 0;
};

const NOT_CONFIRMED_TITLE = <FormattedMessage id="app.registration.almost_done" />;

export const NotConfirmed: FC = () => {
    const [sending, setSending] = useState(false);
    const timeLeft = getInitialTime();
    const [timer, setTimer] = useState<number>(timeLeft);
    const { formatMessage } = useIntl();

    useEffect(() => {
        if (timer > 0) {
            setTimeout(() => {
                setTimer(timer - 1);
            }, 1000);
        } else {
            localStorage.removeItem("confirmAgainAfter");
        }
    }, [timer]);

    const handleSendEmailConfirmation = useCallback(async () => {
        try {
            setSending(true);
            await sendEmailVerification(auth.currentUser);
            setTimer(59);
            localStorage.setItem("confirmAgainAfter", (new Date().getTime() + 59000).toString());
            toast(formatMessage({ id: "app.registration.message.send_verification_email" }));
        } catch (error) {
            toast.danger(formatMessage({ id: getFirebaseErrorMessageByError(error) }));
        }
        setSending(false);
    }, [formatMessage]);

    return (
        <AuthLayout title={NOT_CONFIRMED_TITLE}>
            <FormattedMessage id="app.registration.almost_done_description" tagName="p" />

            {timer > 0 && (
                <p>
                    <FormattedMessage id="app.registration.resend_again_in" /> 00:{addZeros(timer)}
                </p>
            )}

            <Button fullWidth size="lg" onPress={handleSendEmailConfirmation} isDisabled={sending || timer > 0}>
                <FormattedMessage id="app.registration.send_again" />
            </Button>
        </AuthLayout>
    );
};
